var map = {
	"./Biblioteca.svg": 6952,
	"./FondoIdeas.svg": 7932,
	"./Liderazgo.svg": 3696,
	"./Medio-Ambiente.svg": 9416,
	"./Play icon.svg": 9104,
	"./Play.svg": 4716,
	"./Vector.svg": 3268,
	"./Vector_movil.svg": 5428,
	"./art-and-culture-ov.svg": 4168,
	"./art-and-culture.svg": 4892,
	"./arte-y-cultura-ov.svg": 5900,
	"./arte-y-cultura.svg": 9504,
	"./arte.svg": 296,
	"./arte_ov.svg": 4780,
	"./bibli.svg": 9832,
	"./bibli_ov.svg": 92,
	"./biblioteca-ov.svg": 9744,
	"./educ.svg": 9852,
	"./educ_ov.svg": 1000,
	"./educacion-ov.svg": 1824,
	"./educacion.svg": 8936,
	"./education-ov.svg": 9296,
	"./education.svg": 3914,
	"./environment-ov.svg": 7695,
	"./environment.svg": 8676,
	"./estad.svg": 868,
	"./estad_ov.svg": 1120,
	"./estado-de-derecho-ov.svg": 6224,
	"./estado-de-derecho.svg": 6060,
	"./flecha-scroll.svg": 724,
	"./fond2.svg": 9316,
	"./inclusive-prosperity-ov.svg": 884,
	"./inclusive-prosperity.svg": 716,
	"./innovacion-ov.svg": 1092,
	"./innovacion.svg": 492,
	"./innovation-ov.svg": 4512,
	"./innovation.svg": 5884,
	"./inov.svg": 8820,
	"./inov_ov.svg": 1472,
	"./leadership-ov.svg": 532,
	"./leadership.svg": 2079,
	"./liber.svg": 8000,
	"./liber_ov.svg": 1212,
	"./libertad-ov.svg": 8456,
	"./libertad.svg": 680,
	"./liberty-ov.svg": 1184,
	"./liberty.svg": 1380,
	"./library-ov.svg": 4788,
	"./library.svg": 2136,
	"./lider.svg": 6696,
	"./lider_ov.svg": 3676,
	"./liderazgo-ov.svg": 1784,
	"./liderazgo1.svg": 9552,
	"./medio-ambiente-ov.svg": 9988,
	"./medio.svg": 6136,
	"./medio_ov.svg": 3836,
	"./prosp.svg": 786,
	"./prosp_ov.svg": 6684,
	"./prosperidad-incluyente-ov.svg": 1804,
	"./prosperidad-incluyente.svg": 8828,
	"./rbs.svg": 6140,
	"./rule-of-law-ov.svg": 6716,
	"./rule-of-law.svg": 5092
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4876;